import axios from 'axios'
import router from '../router'
var parse = require('json-parse-safe')

// Definindo a base URL padrão da API
axios.defaults.baseURL = process.env.VUE_APP_API_URL || "";

// Adiciona um interceptor de request
axios.interceptors.request.use(
  config => {
    // ---Extração resiliente do token ---
    const rawToken = localStorage.getItem('token')
    const parsed = parse(rawToken)
    
    // Se o parse falhou (token é string pura) usamos o rawToken, senão usamos o .value
    let token = (parsed && parsed.value) ? parsed.value : rawToken;

    if (token && token !== 'undefined' && token !== 'null') {
      // Limpa aspas duplas residuais e garante o formato Bearer puro
      // O Spring Security rejeita o token se ele chegar com aspas no header
      const cleanToken = typeof token === 'string' ? token.replace(/"/g, '') : token
      config.headers['Authorization'] = 'Bearer ' + cleanToken
    }

    // --- IMPORTANTE: Removidos headers de Access-Control manuais ---
    // Manter esses headers no client causa erro de Pre-flight (CORS) 
    // quando o Back-end já tem sua própria política de segurança.
    
    config.withCredentials = false;

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Adiciona um interceptor de response
axios.interceptors.response.use(
  response => {
    return response
  },
  function (error) {
    const originalRequest = error.config

    // Log para monitorar erros no console (F12)
    console.log('Axios Interceptor Error:', error.response ? error.response.status : 'Sem resposta')
 
    if (error.request && error.request.status == 0) {
      return Promise.reject(error)
    }

    // Se der 401 e você quiser redirecionar para o login, descomente abaixo:
    /*
    if (error.response && error.response.status === 401) {
       router.push('/login')
    }
    */

    return Promise.reject(error)
  }
)

export default axios